import React, { useEffect, useState } from 'react';

import { useScript } from 'usehooks-ts';

import { NcLoadingSpinner } from '../NcLoadingSpinner';

export type NcWebComponentPropsT = {
  componentProps: Record<string, unknown>;
  src: string;
  tagName: string;
};

export type NcWebComponentT = React.FC<NcWebComponentPropsT>;

export const NcWebComponent: NcWebComponentT = ({
  componentProps,
  src,
  tagName,
}) => {
  const status = useScript(src);
  const [isDefined, setIsDefined] = useState(false);

  useEffect(() => {
    let isMounted = true;

    customElements.whenDefined(tagName).then(() => {
      if (isMounted) {
        setIsDefined(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [tagName]);

  if (status === 'error') {
    return `Error loading web component: ${tagName}`;
  }

  if (isDefined) {
    return React.createElement(tagName, componentProps);
  }

  return <NcLoadingSpinner />;
};
